class CartFreeSamples extends HHBaseElement {
  constructor() {
    super()

    this.$mainCart = this.closest('main-cart')
    this.$atcLabels = JSON.parse(this.dataset.atcLabels)
    this.limits = Number(this.dataset.limits)
    this.$actions = this.querySelectorAll('.js-free-sample-action')
    this._doFreeSample = this._doFreeSample.bind(this)
    this._addFreeSample = this._addFreeSample.bind(this)
    this._removeFreeSample = this._removeFreeSample.bind(this)
  }

  update(lineItem) {
    this.setAttribute('line-item-quantity', lineItem.quantity)
  }

  connectedCallback() {
    this._attachListeners()
    this.checkLimits()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  handleCartRefreshed(e) {
    this.checkLimits(e.detail)
  }

  checkLimits(cart = this.$mainCart?.cart) {
    if (!cart) {
      console.error('Cart not found. Could not validate free samples')
      return
    }
    if (this.limits === 0) return false

    const numfreeSamplesInCart = cart.items.reduce(
      (acc, cur) =>
        String(cur.properties['_free-sample']) === 'true' ? acc + 1 : acc,
      0
    )
    if (numfreeSamplesInCart >= this.limits) {
      this.querySelectorAll('.main-cart__free-sample:not(.added)').forEach(
        (item) => {
          item.querySelector('button').disabled = true
        }
      )
    } else {
      this.querySelectorAll('.main-cart__free-sample:not(.added)').forEach(
        (item) => {
          item.querySelector('button').disabled = false
        }
      )
    }
  }

  async _doFreeSample(item) {
    const sliderContainer = item.closest('swiper-container')
    sliderContainer.classList.add('processing')

    const parent = item.closest('.main-cart__free-sample')
    if (parent.classList.contains('added')) {
      await this._removeFreeSample(item)
      item.querySelector('span').innerHTML = this.$atcLabels.add
      parent.classList.remove('added')
    } else {
      await this._addFreeSample(item)
      item.querySelector('span').innerHTML = this.$atcLabels.remove
      parent.classList.add('added')
    }
    this.triggerGlobalEvent('main-cart::refresh')
    sliderContainer.classList.remove('processing')
  }

  async _addFreeSample(item) {
    const variant_id = Number(item.dataset.variantId)
    await window.__CART__CONTROLLER__.add(
      [
        {
          id: variant_id,
          quantity: 1,
          properties: {
            '_free-sample': true,
          },
        },
      ],
      true
    )
  }

  async _removeFreeSample(item) {
    const variant_id = Number(item.dataset.variantId)
    await window.__CART__CONTROLLER__.update({
      [variant_id]: 0,
    })
  }

  removedFromCart(key) {
    const sliderContainers = this.querySelectorAll('swiper-container')
    sliderContainers.forEach((item) => item.classList.add('processing'))
    const variant_id = key.split(':')[0]
    this.$actions.forEach((item) => {
      if (item.dataset.variantId === variant_id) {
        item.querySelector('span').innerHTML = this.$atcLabels.add
        item.closest('.main-cart__free-sample').classList.remove('added')
      }
    })

    this.checkLimits()
    sliderContainers.forEach((item) => item.classList.remove('processing'))
  }

  removedAllFromCart() {
    this.checkLimits()
  }

  _attachListeners() {
    this.$actions.forEach((item) => {
      item.addEventListener('click', (event) => this._doFreeSample(item))
    })
    document.addEventListener(
      'main-cart::refreshed',
      this.handleCartRefreshed.bind(this)
    )
  }

  _removeListeners() {
    this.$actions.forEach((item) => {
      item.removeEventListener('click', (event) => this._doFreeSample(item))
    })
    document.removeEventListener(
      'main-cart::refreshed',
      this.handleCartRefreshed.bind(this)
    )
  }
}

window.customElements.define('cart-free-samples', CartFreeSamples)
